import { useLocation } from "react-router";

import queryString from "query-string";
import { useIsStorybook } from "./storyHooks";
import { useSelector } from "store/useSelector";
import { useMemo } from "react";

export default function useQueryString() {
  const isStorybook = useIsStorybook();
  const location = useLocation();
  const mockLocation = useSelector(state => state.legacy.mockLocation);
  return useMemo(
    () =>
      queryString.parse(
        isStorybook && mockLocation ? mockLocation.search : location.search
      ),
    [isStorybook, mockLocation, location]
  );
}
